export default __webpack_public_path__ + "static/media/positioning.beecbb13.png";